export type BentoImageCarouselItemProps = {
  logo: React.ReactNode;
};

export function BentoImageCarouselItem({ logo }: BentoImageCarouselItemProps) {
  return (
    <div className='flex shrink-0 items-center justify-center'>{logo}</div>
  );
}
